// extracted by mini-css-extract-plugin
export default {"adminPanel":"AdminPanel_adminPanel__4o5wC","sidebar":"AdminPanel_sidebar__knnGB","active":"AdminPanel_active__6Edab","content":"AdminPanel_content__bwz3d"};